import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { getMessaging, deleteToken } from "firebase/messaging";
import {ApiURL} from "../../../helpers/APIdata/apiURL"
// Login Redux States
import { LOGIN_USER, LOGOUT_USER, RENEW_TOKEN } from "./actionTypes";
import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  renewTokenError,
  renewTokenSuccess,
} from "./actions";

import { postJwtLogin, tokenRenew } from "../../../helpers/fakebackend_helper";
import { getTokenCompanyId } from "../../../helpers/authToken";
import {
  clearPostLoginRedirect,
  readPostLoginRedirect,
} from "../../../helpers/postLoginRedirect";

import { toast } from "react-toastify";
//bridge for react native
import { postAuthToNative, postLogoutToNative } from "../../../helpers/rnBridge";

function* loginUser({ payload: { user, history } }) {

  try {
    if (process.env.REACT_APP_API_URL) {
      // const response = yield call(postJwtLogin, {
      //   ...user,
      //   Email: user?.email,
      //   Password: user?.password,
      //   DeviceFingerprint: user?.DeviceFingerprint, //google firebase token
      //   EntryUrl: user?.EntryUrl,
      //   cf_turnstile_token: user?.cf_turnstile_token,
      // });

      // Expo Push token injected by the mobile WebView (window.CRMIT_MOBILE)
      const mobile = (typeof window !== "undefined" && window.CRMIT_MOBILE) ? window.CRMIT_MOBILE : null;

      const response = yield call(postJwtLogin, {
        ...user,
        Email: user?.email,
        Password: user?.password,

        // existing (Firebase)
        DeviceFingerprint: user?.DeviceFingerprint, // google firebase token

        // ✅ new (Expo push)
        DeviceExpoPushNotification_Id : mobile?.expoPushToken || null,
        DeviceUniqueIdentification: mobile?.deviceId || null,
        ExpoPlatform: mobile?.platform || null,
        ExpoAppVersion: mobile?.appVersion || mobile?.nativeAppVersion || null,
        ExpoBuildVersion: mobile?.nativeBuildVersion || null,
        ExpoProjectId: mobile?.projectId || null,

        EntryUrl: user?.EntryUrl,
        cf_turnstile_token: user?.cf_turnstile_token,
      });


      if (response.status === 200) {
        localStorage.setItem("authUser", JSON.stringify(response));

        // Remember-me persistence. The whole app reads authUser from localStorage,
        // so the token is always written there. "authPersist" records whether this
        // session should survive a browser restart:
        //   "1" -> remembered (persist across restarts, the default)
        //   "0" -> session-only; App boot clears it on the next fresh browser session
        //          (tracked by the per-session "authSession" sentinel below).
        try {
          const remember = user?.remember !== false; // default to remembered
          if (remember) {
            localStorage.setItem("authPersist", "1");
            sessionStorage.removeItem("authSession");
          } else {
            localStorage.setItem("authPersist", "0");
            sessionStorage.setItem("authSession", "1");
          }
        } catch (_) {
          // ignore storage access errors
        }

        postAuthToNative(response, ApiURL()?.API_URL);
        // ✅ CRITICAL: Add this line to maintain Redux state

        yield put(loginSuccess(response));

        // 1) Read and validate any saved deep-link
        // Change #100336 - only if it was saved from THIS user's session (or
        // from no session at all) and is not stale; otherwise their Default
        // landing page wins. See helpers/postLoginRedirect.
        const stored = readPostLoginRedirect(
          response?.get_staff_data?.Staff_Id
        );
        const deepLink = stored;
        console.log("DeepLink", deepLink);

        // 2) Server flag: forward to local (saved) URL?
        //    Supports multiple casings / legacy names; coerces to string to handle 1/0 or "1"/"0".
        const wantsLocal =
          String(
            response?.get_staff_data?.FlagSendUserToDesiredLocation ?? "0"
          ) === "1";
        console.log(
          "response?.get_staff_data?.OpeningUrl",
          response?.get_staff_data?.OpeningUrl
        );
        // 3) Compute destination once with proper precedence
        const opening = response?.get_staff_data?.OpeningUrl !== null ? response?.get_staff_data?.OpeningUrl : "/dashboard";
        console.log("opening", opening);

        const finalDest = wantsLocal && deepLink ? deepLink : opening;

        // Priority: verify email > pick company > name new device > destination.
        let dest;
        if (response?.data?.FlagEmailVerificationComplete === 0) {
          dest = "/auth/verify-email";
        } else if (response?.data?.linkedcompany_count === 0) {
          dest = "/interm";
        } else if (response?.data?.isNewDevice === 1) {
          // Unrecognised device — stash the onward destination, show the naming screen.
          try {
            localStorage.setItem("device_next_dest", finalDest);
          } catch (_) {
            // ignore storage errors
          }
          dest = "/auth/name-device";
        } else {
          dest = finalDest;
        }
console.log("dest", dest);
        // 4) Cleanup + go
        clearPostLoginRedirect();

        console.log("[login redirect]", {
          stored,
          wantsLocal,
          opening,
          chosen: dest,
        });

        history.push(dest);
      } else {
        console.log("response status not 200", response);
        yield put(apiError(response));
      }
    }
  } catch (error) {
    yield put(apiError(error));
  }
}
const localstorage = localStorage;

function* logoutUser() {
  try {
    // ✅ Try to delete FCM token from Firebase
    const messaging = getMessaging();
    try {
      yield call(() => deleteToken(messaging));
      console.log("✅ FCM token deleted from Firebase");
    } catch (err) {
      console.warn("⚠️ Failed to delete Firebase token", err);
    }

    yield put(logoutUserSuccess(LOGOUT_USER, true));
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }

  // ✅ Local cleanup
  yield call([localstorage, "removeItem"], "authUser");
  yield call([localstorage, "removeItem"], "authPersist");
  yield call([localstorage, "removeItem"], "firebase_fcm_token");
  try {
    sessionStorage.removeItem("authSession");
  } catch (_) {
    // ignore storage access errors
  }
  //removing from mobile storage as well
  postLogoutToNative();
}


function* renewToken() {
  try {
    // The token this renewal is issued FROM. FetchAPI reads the bearer out of
    // localStorage at fetch time, so this is the token the request carries.
    let var___token_at_request = null;
    try {
      var___token_at_request =
        JSON.parse(localStorage.getItem("authUser"))?.token || null;
    } catch (_) {
      var___token_at_request = null;
    }

    const response = yield call(tokenRenew);

    if (response.status === 200) {
      const authUser = JSON.parse(localStorage.getItem("authUser"));

      // Company switch guard.
      //
      // The backend picks the company database from the JWT's
      // Company_IdExternal claim and nothing else, so authUser.token IS the
      // company the session is in. A renewal is a round trip: if the user
      // switches company while one is in flight, the response carries a token
      // minted for the company they just LEFT. Writing it back here left the
      // session split - the header logo, menus and company name all show the
      // new company (get_company_data was written by the switch) while every
      // data request went to the old one. It also dragged the old company's
      // get_staff_data and capability lists back in with it.
      //
      // Two independent checks, both cheap:
      //   1. the stored token changed while we were in flight, so this response
      //      answers a session that no longer exists;
      //   2. the renewed token does not address the company the UI is showing.
      // Either way the response is stale, so drop it whole. The next scheduled
      // renewal runs against the current token, so nothing is lost.
      if (
        var___token_at_request &&
        authUser?.token &&
        authUser.token !== var___token_at_request
      ) {
        console.warn(
          "renewToken: session changed while the renewal was in flight - discarding the stale response"
        );
        return;
      }

      const var___renewed_company_id = getTokenCompanyId(response.token);
      const var___current_company_id =
        authUser?.get_company_data?.Company_IdExternal;

      if (
        var___renewed_company_id &&
        var___current_company_id &&
        var___renewed_company_id !== var___current_company_id
      ) {
        console.warn(
          "renewToken: renewed token is for company",
          var___renewed_company_id,
          "but the session is now in",
          var___current_company_id,
          "- discarding the stale response"
        );
        return;
      }

      authUser.token = response.token;

      // Task 24685 - carry the refreshed session snapshot across.
      //
      // authUser is a login snapshot, and two parts of it are read everywhere
      // and change underneath the user: get_securityauthcapability_list (which
      // Gate.js gates every screen on) and get_staff_data (which the sidebar is
      // built from, via MenuNav_Id). Neither used to be refreshed here, so an
      // admin changing somebody's role or menu achieved nothing until that
      // person next logged out and back in.
      //
      // Both are applied ONLY when the response actually carries them. A
      // frontend deployed ahead of the backend half would otherwise blank the
      // capability list and lock everyone out of their own menus.
      if (response.get_securityauthcapability_list) {
        authUser.get_securityauthcapability_list =
          response.get_securityauthcapability_list;
      }
      if (response.get_securityauthrole_list) {
        authUser.get_securityauthrole_list = response.get_securityauthrole_list;
      }
      if (response.get_staff_data) {
        authUser.get_staff_data = response.get_staff_data;
      }

      authUser.get_company_data = {
        ...authUser.get_company_data,
        Company_SubscriptionFreeTrialStartDate:
          authUser.get_company_data.Company_SubscriptionFreeTrialStartDate,
        Company_SubscriptionFreeTrialEndDate:
          authUser.get_company_data.Company_SubscriptionFreeTrialEndDate,
      };
      localStorage.setItem("authUser", JSON.stringify(authUser));
      //update Mobile as well
      postAuthToNative(authUser);
      postAuthToNative(authUser, ApiURL()?.API_URL);

      // ✅ CRITICAL: Add this line to maintain Redux state
      yield put(loginSuccess(authUser));
    }
  } catch (error) {
    // Only reached for transient failures (network/parse). tokenRenew() goes
    // through FetchAPI, so a genuine auth failure (401 - the token is no longer
    // valid) is handled centrally there: it clears the stored session and
    // redirects to /login. We deliberately do NOT log the user out on a
    // transient error, otherwise a brief network blip during the background
    // renewal would eject an otherwise-valid session.
    yield put(renewTokenError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  // yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
  // takeLatest, not takeEvery: App.js fires a renewal on every window focus and
  // every visibilitychange, so overlapping renewals were routine and each one
  // was another chance to write back a token from a superseded session.
  yield takeLatest(RENEW_TOKEN, renewToken);
}

export default authSaga;
